enum NodeMeasurementType {
    Measured = 'M',
    Calculated = 'L',
}

export default NodeMeasurementType;
